import { invalidateAllProjectQueries } from "@/modules/work/projects/project/queries";
import { toast } from "sonner";
import { updateProject } from "./api";
import { useMutation } from "@tanstack/react-query";

function buildPayload(values) {
  const payload = {};
  if ("logo" in values) {
    payload.logo = values.logo;
  }
  if ("sales_coordinator" in values) {
    payload.sales_coordinator = values.sales_coordinator?.id;
  }

  if ("coordinator" in values) {
    payload.coordinator = values.coordinator?.id;
  }

  if ("account_manager" in values) {
    payload.account_manager = values.account_manager?.id;
  }

  if ("legal_entity" in values) {
    payload.legal_entity = values.legal_entity?.id;
  }

  if ("client" in values) {
    payload.client = values.client?.id;
  }

  if ("tags" in values) {
    if (Array.isArray(values.tags)) {
      payload.tags = values.tags.map((t) => ({
        tag: typeof t === "object" ? t?.id : t,
      }));
    } else {
      payload.tags = values.tags;
    }
  }

  // countries is a M2M via projects__countries__countries; the form sends a Directus
  // { create, update, delete } change set built against the loaded junction rows.
  if ("countries" in values) {
    const { create = [], delete: remove = [] } = values.countries || {};
    if (create.length || remove.length) {
      payload.countries = { create, update: [], delete: remove };
    }
  }
  Object.entries(values).forEach(([key, value]) => {
    if (
      !["logo", "sales_coordinator", "coordinator", "client", "account_manager", "tags", "countries"].includes(key)
    ) {
      payload[key] = value;
    }
  });

  return payload;
}

export function useUpdateProject() {
  return useMutation({
    mutationFn: async ({ projectId, values }) => {
      const payload = buildPayload(values);

      const response = await updateProject({ projectId, item: payload });
      return response;
    },
    onSuccess: () => {
      toast.success("Project Updated Successfully");
      invalidateAllProjectQueries();
    },
    onError: (error) => {
      toast.error(error.message);
      console.log(error.message);
    },
  });
}
